import { render, staticRenderFns } from "./ShowLegacyBlockListButton.vue?vue&type=template&id=37206f05&"
import script from "./ShowLegacyBlockListButton.vue?vue&type=script&lang=js&"
export * from "./ShowLegacyBlockListButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports